export interface ISelectOption {
	title: string | Record<string, string | number>;
	value: string | number;
}

export const CHECK_ALL_OPTION_VALUE = 'CHECK_ALL_OPTION_VALUE';

export const CHECK_ALL_OPTION = {
	title: 'title',
	value: CHECK_ALL_OPTION_VALUE,
};
